// models specific for rich dropdown
const dropdownContentObj: DropdownContentObj = { title: '', description: '', disabled: false, selected: false};

export class DropdownObj {
  public topic: string = '';
  public selected: DropdownContentObj = dropdownContentObj;
  public options: DropdownContentObj[] = [];
  public disabled: boolean = false;

  public setSelected(option: DropdownContentObj): void {
    this.selected.selected = false;
    option.selected = true;
    this.selected = option;
  }
}

export class DropdownContentObj {
  public title: string = '';
  public description: string = '';
  public disabled: boolean = false;
  public selected: boolean = false;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/richDropdown.ts